import { RichTextFeature } from 'features/Modules/RichText';
import { convertForRichTextFeature } from 'features/Modules/RichText/richTextFeatureAdapter';

export const CollapseTextFeature: React.FC<Content.CollapseText> = ({ content }) => (
	<RichTextFeature content={convertForRichTextFeature(content?.properties?.text?.markup)} />
);
